import React, { useEffect, useRef, useState } from "react";
import { useGetSecurityMarginMatchedOrders } from "../../context/contractDataLoaderService";
import {
  contractAddress,
  MarginIssueManager,
} from "@verified-network/verified-sdk";
import Loader from "../../components/loader";
import { useGlobal } from "../../context/globalContext";
import UiTable from "../../components/table/Table";
import { Button, Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import UiButton from "../../components/button";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import TextInput from "../../components/textinput/TextInput";
import VerticallyModal from "../../components/modal/VerticallyModal";
import { ethers } from "ethers";
import {
  formatTimestamp,
  generateSecureCloidHyper,
  getAllVerifiedCashBalances,
  getAndCalculateFundingRateHyper,
} from "../../utils/helpers";
import { toast } from "react-toastify";
import {
  networkLoanConstant,
  networks,
  SuccessToast,
  ToastOptions,
} from "../../utils/constants";
import { filter } from "lodash";

function InvestorInfo(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    isUpdate,
    setIsUpdate,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [tableData, setTableData] = useState([]);
  const [shouldReferesh, setShouldReferesh] = useState(false);
  const securityAddress = props.params.securityAddress;
  const poolId = props.params.poolId;
  let { data: marginTrades, loading: _loading } =
    useGetSecurityMarginMatchedOrders(securityAddress, poolId, shouldReferesh);

  const modalContent = useRef(null);
  const [modalView, setModalView] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [columnSelected, setColumnSelected] = useState({
    security: "",
    currency: "",
    currencyName: "",
    currencySymbol: "",
    currencyDecimals: 0,
    marginTokensPair: "",
    securitySymbol: "",
    balance: "0.0000",
    balanceRaw: "0",
    type: "",
    brokerage: "",
    orderRef: "",
    creator: "",
    matchedWith: "",
    type: "",
    userDepositedCollateral: 0,
    qty: 0,
    duration: "",
  });
  const [isFinancing, setIsFinancing] = useState(false);
  const [financingTitle, setFinancingTitle] = useState("Select Financing");
  const [rateTitle, setRateTitle] = useState("Select Rate Tenure");
  const [rate, setRate] = useState("0");
  const [financingAmounts, setFinancingAmounts] = useState({
    bid: 0,
    offer: 0,
  });
  const [isDividends, setIsDividends] = useState(false);
  const [dividendsTitle, setDividendsTitle] = useState("Select Dividends");
  const [dividendsAmounts, setDividendsAmounts] = useState({
    bid: 0,
    offer: 0,
  });
  const [isSwaps, setIsSwaps] = useState(false);
  const [swapsTitle, setSwapsTitle] = useState("Select Swaps");
  const [swapsAmounts, setSwapsAmounts] = useState({
    short: 0,
    long: 0,
  });

  const [showReport, setShowReport] = useState(false);
  const [contractCallLoading, setContractCallLoading] = useState(false);
  const [currentHyperPrices, setCurrentHyperPrices] = useState({});
  const [isHyperConnected, setIsHyperConnected] = useState(false);
  const [isBrokerageFetchLoading, setIsBrokerageFetchLoading] = useState(false);
  const [fetchedBrokerageOrder, setFetchedBrokerageOrder] = useState({});
  const [defaultBrokerageOrder, setDefaultBrokerageOrder] = useState({});
  const [defaultBrokerageOrderDt, setDefaultBrokerageOrderDt] = useState([]);
  const [defaultBrokerageOrderOpposite, setDefaultBrokerageOrderOpposite] =
    useState([]);
  const [fundingRateHyper, setFundingRateHyper] = useState("Errored");

  const wsRef = useRef(null);

  let headers;
  let pageHeading;

  let marginManagerContractVer;

  if (provider && provider.getSigner && chainId && address) {
    if (contractAddress[chainId].BalancerMarginIssueManager) {
      marginManagerContractVer = new MarginIssueManager(
        signer,
        contractAddress[chainId].BalancerMarginIssueManager,
      );
    }
  }

  useEffect(() => {
    const isTestnet = Object.keys(networks)?.includes("11155111");
    const wsUrl = isTestnet
      ? "wss://api.hyperliquid-testnet.xyz/ws"
      : "wss://api.hyperliquid.xyz/ws";

    wsRef.current = new WebSocket(wsUrl);

    wsRef.current.onopen = () => {
      setIsHyperConnected(true);

      const subscribeMessage = {
        method: "subscribe",
        subscription: { type: "allMids" },
      };
      wsRef.current?.send(JSON.stringify(subscribeMessage));
    };

    wsRef.current.onmessage = (event) => {
      const response = JSON.parse(event.data);

      if (response.channel === "allMids" && response.data?.mids) {
        setCurrentHyperPrices(
          Object.assign(
            {},
            ...Object.entries(response.data.mids)
              .filter(([mid]) => !mid.startsWith("#") && !mid.startsWith("@"))
              .map(([mid, value]) => ({ [mid]: value })),
          ),
        );
      }
    };

    // 4. Event listener: Handle connection closure
    wsRef.current.onclose = () => {
      setIsHyperConnected(false);
    };

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, []);

  useEffect(() => {
    const fetchOrderStopOrCloseOnBrokerage = async () => {
      setIsBrokerageFetchLoading(true);
      if (columnSelected?.brokerage === "HYPERLIQUID") {
        const isTestnet = Object.keys(networks)?.includes("11155111");
        let orderFetched = false;
        //check for stopLoss first incase it got triggered
        const stopOrderReq = await fetch(
          isTestnet
            ? "https://api.hyperliquid-testnet.xyz/info"
            : "https://hyperliquid.xyz/info",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              type: "orderStatus",
              user: networkLoanConstant[chainId]?.Brokerages["HYPERLIQUID"],
              oid: generateSecureCloidHyper(
                columnSelected?.orderRef,
                true,
                false,
              ),
            }),
          },
        );

        const stopOrderRes = await stopOrderReq.json();

        const orderSt = stopOrderRes?.order?.status;

        if (orderSt === "filled" || orderSt === "triggered") {
          orderFetched = true;
          setFetchedBrokerageOrder({
            ...stopOrderRes?.order?.order,
            fetchedType: "stoploss",
          });
        }

        //if no stoploss check for closed
        if (!orderFetched) {
          const closeOrderReq = await fetch(
            isTestnet
              ? "https://api.hyperliquid-testnet.xyz/info"
              : "https://hyperliquid.xyz/info",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                type: "orderStatus",
                user: networkLoanConstant[chainId]?.Brokerages["HYPERLIQUID"],
                oid: generateSecureCloidHyper(
                  columnSelected?.orderRef,
                  false,
                  true,
                ),
              }),
            },
          );

          const closeOrderRes = await closeOrderReq.json();

          const closeOrderSt = closeOrderRes?.order?.status;

          if (closeOrderSt === "filled" || closeOrderSt === "triggered") {
            orderFetched = true;
            setFetchedBrokerageOrder({
              ...closeOrderRes?.order?.order,
              fetchedType: "closed",
            });
          }
        }

        const orderReq = await fetch(
          isTestnet
            ? "https://api.hyperliquid-testnet.xyz/info"
            : "https://hyperliquid.xyz/info",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              type: "orderStatus",
              user: networkLoanConstant[chainId]?.Brokerages["HYPERLIQUID"],
              oid: generateSecureCloidHyper(columnSelected?.orderRef),
            }),
          },
        );

        const orderRes = await orderReq.json();

        const defaultOrder = orderRes?.order?.order;

        setDefaultBrokerageOrder(defaultOrder);

        if (defaultOrder) {
          const closeOrderReq = await fetch(
            isTestnet
              ? "https://api.hyperliquid-testnet.xyz/info"
              : "https://hyperliquid.xyz/info",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                type: "userFills",
                user: networkLoanConstant[chainId]?.Brokerages["HYPERLIQUID"],
              }),
            },
          );

          const closeOrderRes = await closeOrderReq.json();
          const defaultOrderDt = (closeOrderRes || []).filter(
            (ord) => ord?.oid === defaultOrder?.oid,
          );

          if (defaultOrderDt) {
            setDefaultBrokerageOrderDt(defaultOrderDt);
          }

          const defaultOrderAmount = Number(defaultOrder?.origSz || 0);
          const defaultOrderTime = Number(defaultOrder?.timestamp || 0);

          const sideToMatch =
            columnSelected?.type?.toLowerCase() === "buy/long"
              ? "close long"
              : "close short";

          const closeOrders = (closeOrderRes || []).filter((ord) => {
            const isCorrectDir = ord?.dir?.toLowerCase() === sideToMatch;
            const isAfterDefaultOrder = Number(ord?.time) > defaultOrderTime;
            const isValidSize = Number(ord?.sz) <= defaultOrderAmount;
            const isOppositeSide = ord?.side !== defaultOrder?.side;
            const isValidStartPosition =
              Number(ord?.startPosition?.toString()?.replace("-", "")) <=
              defaultOrderAmount;

            return (
              isCorrectDir &&
              isAfterDefaultOrder &&
              isValidSize &&
              isOppositeSide &&
              isValidStartPosition
            );
          });

          let filledAmount = 0;
          let currentPosition = 0;
          let ordersToUse = [];

          while (filledAmount < defaultOrderAmount) {
            const positionsOrders = closeOrders
              .filter((ord) => {
                const targetPosition =
                  currentPosition === 0
                    ? defaultOrderAmount?.toFixed(5)
                    : currentPosition?.toFixed(5); //no token with sizDecimals over 5????
                return (
                  Number(
                    ord?.startPosition?.toString()?.replace("-", ""),
                  )?.toFixed(5) === targetPosition
                );
              })
              .sort((a, b) => Number(b.time) - Number(a.time)); //sort with time to target the last one

            if (!positionsOrders.length) {
              break;
            }

            const lastPositionsOrder =
              positionsOrders[positionsOrders.length - 1];

            filledAmount += Number(lastPositionsOrder?.sz || 0); //update filled amount to break out of loop when fully filled
            currentPosition =
              Number(
                lastPositionsOrder?.startPosition
                  ?.toString()
                  ?.replace("-", "") || 0,
              ) - Number(lastPositionsOrder?.sz || 0);

            ordersToUse.push(lastPositionsOrder); // collect all order after. for pnl calculation
          }

          setDefaultBrokerageOrderOpposite(ordersToUse);

          if (ordersToUse?.length > 0 && defaultOrderDt?.length > 0) {
            const orderCloseTimeInMilliseconds = Number(
              ordersToUse?.sort((a, b) => Number(b?.time) - Number(a?.time))[0]
                ?.time,
            );
            const orderOpenTimeInMilliseconds = Number(
              defaultOrderDt?.sort(
                (a, b) => Number(b?.time) - Number(a?.time),
              )[0]?.time,
            );

            const TotalFundingRateForOrderTime =
              await getAndCalculateFundingRateHyper(
                defaultOrderDt[0]?.coin,
                orderOpenTimeInMilliseconds,
                orderCloseTimeInMilliseconds,
              );

            if (TotalFundingRateForOrderTime !== null) {
              setFundingRateHyper(
                TotalFundingRateForOrderTime?.toString()?.replace("-", ""),
              );
            }
          }
        }
        setIsBrokerageFetchLoading(false);
      }

      setIsBrokerageFetchLoading(false);
    };

    if (columnSelected?.brokerage) {
      fetchOrderStopOrCloseOnBrokerage();
    }
  }, [columnSelected]);

  pageHeading = "Margin Trades";
  headers = [
    { label: "Creator", val: "transferorNameAsLink" },
    { label: "type", val: "type" },
    { label: "Qty", val: "securityTradedFmt" },
    { label: "Matched", val: "transfereeNameAsLink" },
    { label: "Execution Date(UTC)", val: "date" },
    { label: "Amount", val: "cashTradedFmt" },
    { label: "Status", val: "status" },
    { label: "Closed Date(UTC)", val: "closedDate" },
    { label: "Last Settled(UTC)", val: "lastPnlDate" },
    { label: "Call Action", val: "marginTradesAction" },
  ];

  const commonProps = {
    modalView,
    updateModalView: setModalView,
    showModal,
    updateShowModal: setShowModal,
    columnSelected,
    updateColumnSelected: setColumnSelected,
    chainId,
    marginManagerContractVer,
    web3,
    account,
  };

  const handleModalHide = () => {
    setModalView(1);
    setShowModal(false);
    setIsFinancing(false);
    setIsDividends(false);
    setIsSwaps(false);
    setFinancingTitle("Select Financing");
    setDividendsTitle("Select Dividends");
    setSwapsTitle("Select Swaps");
    setFinancingAmounts({ bid: 0, offer: 0 });
    setDividendsAmounts({ bid: 0, offer: 0 });
    setSwapsAmounts({ short: 0, long: 0 });
    setRate(0);
    setRateTitle("Select Rate Tenure");
    setShowReport(false);
  };

  const getInterestRatesInSeconds = (Amounts, tenureToUse, decimalsToUse) => {
    if (Number(Amounts["bid"]) >= 0) {
      const bidInSeconds =
        Number(ethers.utils.parseEther(Number(Amounts?.bid)?.toFixed(18))) /
        tenureToUse;

      const offerInSeconds =
        Number(ethers.utils.parseEther(Number(Amounts?.offer)?.toFixed(18))) /
        tenureToUse;
      return {
        bid: bidInSeconds?.toFixed(0),
        offer: offerInSeconds?.toFixed(0),
      };
    } else if (Number(Amounts["short"]) >= 0) {
      const shortInSeconds =
        Number(ethers.utils.parseEther(Number(Amounts?.short)?.toFixed(18))) /
        tenureToUse;
      const longInSeconds =
        Number(ethers.utils.parseEther(Number(Amounts?.long)?.toFixed(18))) /
        tenureToUse;
      return {
        short: shortInSeconds?.toFixed(0),
        long: longInSeconds?.toFixed(0),
      };
    }
    return;
  };

  const handleSettleAccount = async () => {
    let isValidated = true;
    if (
      (columnSelected?.brokerage !== "HYPERLIQUID" && !isFinancing) ||
      (columnSelected?.brokerage !== "HYPERLIQUID" &&
        financingAmounts.bid === 0) ||
      (columnSelected?.brokerage !== "HYPERLIQUID" &&
        financingAmounts.offer === 0)
    ) {
      alert("Input Financing Interest Percentages");
      isValidated = false;
    }
    if (
      columnSelected?.brokerage === "HYPERLIQUID" &&
      fundingRateHyper === "Errored"
    ) {
      alert("Invalid Calculated Funding Rates");
      isValidated = false;
    }
    if (
      (isDividends && dividendsAmounts.bid === 0) ||
      (isDividends && dividendsAmounts.offer === 0)
    ) {
      alert("Input Dividend  Percentages");
      isValidated = false;
    }

    if (
      columnSelected?.brokerage !== "HYPERLIQUID" &&
      rateTitle === "Select Rate Tenure"
    ) {
      alert("Select Rate Tenure");
      isValidated = false;
    }
    if (columnSelected?.brokerage !== "HYPERLIQUID" && rate === 0) {
      alert("Input Rate Tenure");
      isValidated = false;
    }

    if (defaultBrokerageOrderOpposite?.length === 0) {
      alert("Invalid opposite closed orders");
      isValidated = false;
    }
    if (defaultBrokerageOrderOpposite?.length === 0) {
      alert("Invalid opposite closed orders");
      isValidated = false;
    }
    const closedSize = defaultBrokerageOrderOpposite.reduce(
      (sum, item) => sum + Number(item.sz || 0),
      0,
    );
    if (
      closedSize <
      Number(columnSelected?.qty)?.toFixed(
        closedSize?.toString()?.split(".")[1]?.length,
      )
    ) {
      alert("Opposite closed orders size is lesser than order quantity");
      isValidated = false;
    }
    const tenureToUse =
      columnSelected?.brokerage === "HYPERLIQUID"
        ? 1 * 60 * 60
        : rateTitle?.toLowerCase() === "hours"
          ? rate * 60 * 60
          : rateTitle?.toLowerCase() === "days"
            ? rate * 24 * 60 * 60
            : 0;

    if (tenureToUse === 0) {
      alert("Invalid rate tenure. Verify rate tenure and try again.");
      isValidated = false;
    }

    if (Number(columnSelected?.currencyDecimals) === 0) {
      alert("Unexpected error");
      isValidated = false;
    }

    if (
      Number(
        defaultBrokerageOrderOpposite?.sort(
          (a, b) => Number(b?.time) - Number(a?.time),
        )[0]?.time,
      ) <= 0
    ) {
      alert("Unexpected error. Cannot Trade Close Time.");
      isValidated = false;
    }

    if (tenureToUse > 0) {
      const financingRates = getInterestRatesInSeconds(
        columnSelected?.brokerage === "HYPERLIQUID"
          ? { bid: Number(fundingRateHyper), offer: Number(fundingRateHyper) }
          : financingAmounts,
        tenureToUse,
        columnSelected?.currencyDecimals,
      );
      let dividendRates = { bid: 0, offer: 0 };
      // let swapRates = { short: 0, long: 0 };
      if (dividendsAmounts.bid !== 0 && dividendsAmounts.offer !== 0) {
        dividendRates = getInterestRatesInSeconds(
          dividendsAmounts,
          tenureToUse,
          columnSelected?.currencyDecimals,
        );
      }

      // if (swapsAmounts.short !== 0 && swapsAmounts.long !== 0) {
      //   swapRates = getInterestRatesInSeconds(
      //     swapsAmounts,
      //     tenureToUse,
      //     columnSelected?.currencyDecimals,
      //   );
      // }
      if (isValidated && financingRates) {
        const calculatedPnl = (
          Number(columnSelected?.userDepositedCollateral) +
          Number(
            defaultBrokerageOrderOpposite.reduce(
              (sum, item) => sum + Number(item.closedPnl || 0),
              0,
            ),
          ) -
          Number(
            defaultBrokerageOrderOpposite.reduce(
              (sum, item) => sum + Number(item.fee || 0),
              0,
            ) +
              defaultBrokerageOrderDt.reduce(
                (sum, item) => sum + Number(item.fee || 0),
                0,
              ),
          )
        )?.toFixed(Number(columnSelected?.currencyDecimals));

        const calculatedPnlFmt = ethers.utils
          .parseUnits(
            calculatedPnl?.toString(),
            columnSelected?.currencyDecimals?.toString(),
          )
          ?.toString();
        setContractCallLoading(true);

        console.log(
          "sending: ",
          columnSelected?.orderRef,
          columnSelected.security,
          columnSelected.currency,
          financingRates.bid.toString(),
          financingRates.offer.toString(),
          dividendRates.bid.toString(),
          dividendRates.offer.toString(),
          calculatedPnlFmt,
          Math.floor(
            Number(
              defaultBrokerageOrderOpposite?.sort(
                (a, b) => Number(b?.time) - Number(a?.time),
              )[0]?.time,
            ) / 1000,
          )?.toString(),
        );

        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account,
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setContractCallLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions,
            );

            return;
          }
          paymentToken = cashTokens[0];
          const txQuote = await marginManagerContractVer._getMeeQuote(
            cashTokens[0]?.address,
            "onSettle",
            [
              columnSelected?.orderRef,
              columnSelected.security,
              columnSelected.currency,
              financingRates.bid.toString(),
              financingRates.offer.toString(),
              dividendRates.bid.toString(),
              dividendRates.offer.toString(),
              calculatedPnlFmt,
              Math.floor(
                Number(
                  defaultBrokerageOrderOpposite?.sort(
                    (a, b) => Number(b?.time) - Number(a?.time),
                  )[0]?.time,
                ) / 1000,
              )?.toString(),
            ],
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setContractCallLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions,
            );

            return;
          }
        }

        await marginManagerContractVer
          .onSettle(
            columnSelected?.orderRef,
            columnSelected.security,
            columnSelected.currency,
            financingRates.bid.toString(),
            financingRates.offer.toString(),
            dividendRates.bid.toString(),
            dividendRates.offer.toString(),
            calculatedPnlFmt,
            Math.floor(
              Number(
                defaultBrokerageOrderOpposite?.sort(
                  (a, b) => Number(b?.time) - Number(a?.time),
                )[0]?.time,
              ) / 1000,
            )?.toString(),
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )
          .then((res) => {
            setContractCallLoading(false);
            if (res?.status === 0) {
              setShowModal(false);
              setIsFinancing(false);
              setIsDividends(false);
              setIsSwaps(false);
              setFinancingTitle("Select Financing");
              setDividendsTitle("Select Dividends");
              setSwapsTitle("Select Swaps");
              setFinancingAmounts({ bid: 0, offer: 0 });
              setDividendsAmounts({ bid: 0, offer: 0 });
              // setSwapsAmounts({ short: 0, long: 0 });
              const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
              toast.success(
                SuccessToast(transactionLink, "Account settled succesfully"),
                ToastOptions,
              );
              setShouldReferesh(!shouldReferesh);
            } else {
              toast.error("settle account transaction failed", ToastOptions);
            }
          })
          .catch((err) => {
            setContractCallLoading(false);
            console.log("err: ", err);
            toast.error("settle account transaction failed", ToastOptions);
          });
      }
    }
  };

  let message, heading;
  if (modalView === 3) {
    heading = `Settle ${columnSelected?.type} Trade`;
    message = (
      <>
        {contractCallLoading ? <Loader /> : null}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Brokerage:</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>{columnSelected?.brokerage}</p>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Order Creator:</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>{columnSelected?.creator}</p>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Matched With:</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>{columnSelected?.matchedWith}</p>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Order Reference:</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>{`${columnSelected?.orderRef?.substring(0, 12)}...${columnSelected?.orderRef?.substring(columnSelected?.orderRef?.length - 12, columnSelected?.orderRef?.length)}`}</p>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Trade Duration: </b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                {isBrokerageFetchLoading && <p>Calculating...</p>}
                {!isBrokerageFetchLoading && (
                  <p>
                    {Number(
                      defaultBrokerageOrderOpposite?.sort(
                        (a, b) => Number(b?.time) - Number(a?.time),
                      )[0]?.time,
                    ) -
                      Number(
                        defaultBrokerageOrderDt?.sort(
                          (a, b) => Number(b?.time) - Number(a?.time),
                        )[0]?.time,
                      ) >=
                    0
                      ? formatTimestamp(
                          Number(
                            defaultBrokerageOrderOpposite?.sort(
                              (a, b) => Number(b?.time) - Number(a?.time),
                            )[0]?.time,
                          ) -
                            Number(
                              defaultBrokerageOrderDt?.sort(
                                (a, b) => Number(b?.time) - Number(a?.time),
                              )[0]?.time,
                            ),
                        )
                      : columnSelected?.duration}
                  </p>
                )}
              </Col>
            </Row>
            {columnSelected?.brokerage !== "HYPERLIQUID" && (
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 4, offset: 2 }} className="text-left">
                  <b>Rate Tenure:</b>
                </Col>
                <Col className="pl-0" xs={3.5}>
                  <DropdownButton title={rateTitle}>
                    <DropdownItem
                      key={1}
                      onClick={() => {
                        setRateTitle("Days");
                      }}
                    >
                      Days
                    </DropdownItem>
                    <DropdownItem
                      kwy={2}
                      onClick={() => {
                        setRateTitle("Hours");
                      }}
                    >
                      Hours
                    </DropdownItem>
                  </DropdownButton>
                </Col>
              </Row>
            )}
            {rateTitle !== "Select Rate Tenure" && (
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 4, offset: 2 }} className="text-left">
                  <b>Input Rate Tenure</b>
                </Col>
                <Col className="pl-0" xs={3.5}>
                  <TextInput
                    placeholder={`Rate tenure in ${rateTitle?.toLowerCase()}`}
                    fieldType="number"
                    onChange={(e) => {
                      Number(e.target.value) != NaN
                        ? setRate(Number(e.target.value))
                        : setRate(Number(0));
                    }}
                    required
                  />
                </Col>
              </Row>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Financing</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton title={financingTitle}>
                  <DropdownItem
                    key={1}
                    onClick={() => {
                      setShowReport(false);
                      setIsFinancing(true);
                      setFinancingTitle("True");
                    }}
                  >
                    True
                  </DropdownItem>
                  <DropdownItem
                    kwy={2}
                    onClick={() => {
                      setShowReport(false);
                      setIsFinancing(false);
                      setFinancingTitle("False");
                      setFinancingAmounts({ bid: 0, offer: 0 });
                    }}
                  >
                    False
                  </DropdownItem>
                </DropdownButton>
              </Col>
            </Row>
            {isFinancing && (
              <React.Fragment>
                {columnSelected?.brokerage === "HYPERLIQUID" && (
                  <React.Fragment>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Bid</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <TextInput
                          placeholder="Finacing bid"
                          fieldType="text"
                          disabled={true}
                          value={
                            isBrokerageFetchLoading
                              ? "Calculating..."
                              : fundingRateHyper
                          }
                          required
                        />
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Offer</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <TextInput
                          placeholder="Finacing bid"
                          fieldType="text"
                          disabled={true}
                          value={
                            isBrokerageFetchLoading
                              ? "Calculating..."
                              : fundingRateHyper
                          }
                          required
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                )}
                {columnSelected?.brokerage !== "HYPERLIQUID" && (
                  <React.Fragment>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Bid</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <TextInput
                          placeholder="Finacing bid"
                          fieldType="number"
                          onChange={(e) => {
                            setShowReport(false);
                            Number(e.target.value) != NaN
                              ? (financingAmounts.bid = Number(e.target.value))
                              : (financingAmounts.bid = 0);
                          }}
                          required
                        />
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Offer</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <TextInput
                          placeholder="Finacing offer"
                          fieldType="number"
                          onChange={(e) => {
                            setShowReport(false);
                            Number(e.target.value) != NaN
                              ? (financingAmounts.offer = Number(
                                  e.target.value,
                                ))
                              : (financingAmounts.offer = 0);
                          }}
                          required
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Dividend</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton title={dividendsTitle}>
                  <DropdownItem
                    key={1}
                    onClick={() => {
                      setShowReport(false);
                      setIsDividends(true);
                      setDividendsTitle("True");
                    }}
                  >
                    True
                  </DropdownItem>
                  <DropdownItem
                    kwy={2}
                    onClick={() => {
                      setShowReport(false);
                      setIsDividends(false);
                      setDividendsTitle("False");
                      setDividendsAmounts({ bid: 0, offer: 0 });
                    }}
                  >
                    False
                  </DropdownItem>
                </DropdownButton>
              </Col>
            </Row>
            {isDividends && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Dividend Bid </b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Dividend bid "
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (dividendsAmounts.bid = Number(e.target.value))
                          : (dividendsAmounts.bid = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Dividend Offer </b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Dividend offer"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (dividendsAmounts.offer = Number(e.target.value))
                          : (dividendsAmounts.offer = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
              </>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Swaps</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton title={swapsTitle}>
                  <DropdownItem
                    key={1}
                    onClick={() => {
                      setShowReport(false);
                      setIsSwaps(true);
                      setSwapsTitle("True");
                    }}
                  >
                    True
                  </DropdownItem>
                  <DropdownItem
                    kwy={2}
                    onClick={() => {
                      setShowReport(false);
                      setIsSwaps(false);
                      setSwapsTitle("False");
                      setSwapsAmounts({ short: 0, long: 0 });
                    }}
                  >
                    False
                  </DropdownItem>
                </DropdownButton>
              </Col>
            </Row>
            {isSwaps && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Swap Short</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Swap short in"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (swapsAmounts.short = Number(e.target.value))
                          : (swapsAmounts.short = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Swap Long</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Swap long in"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (swapsAmounts.long = Number(e.target.value))
                          : (swapsAmounts.long = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
              </>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>PNL Report</b>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Trade PNL</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                {isBrokerageFetchLoading && <p>Calculating...</p>}
                {!isBrokerageFetchLoading && (
                  <p>
                    {defaultBrokerageOrderOpposite.reduce(
                      (sum, item) => sum + Number(item.closedPnl || 0),
                      0,
                    )}{" "}
                    {columnSelected?.currencySymbol}
                  </p>
                )}
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Trade Fee</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                {isBrokerageFetchLoading && <p>Calculating...</p>}
                {!isBrokerageFetchLoading && (
                  <p>
                    {defaultBrokerageOrderDt.reduce(
                      (sum, item) => sum + Number(item.fee || 0),
                      0,
                    )}{" "}
                    {defaultBrokerageOrderDt[0]?.feeToken}
                  </p>
                )}
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Close Fee</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                {isBrokerageFetchLoading && <p>Calculating...</p>}
                {!isBrokerageFetchLoading && (
                  <p>
                    {defaultBrokerageOrderOpposite.reduce(
                      (sum, item) => sum + Number(item.fee || 0),
                      0,
                    )}{" "}
                    {defaultBrokerageOrderOpposite[0]?.feeToken}
                  </p>
                )}
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Total Deposited Collateral</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>
                  {columnSelected?.userDepositedCollateral?.toFixed(
                    Number(columnSelected?.currencyDecimals),
                  )}{" "}
                  {columnSelected?.currencySymbol}
                </p>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Order QTY</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>
                  {Number(columnSelected?.qty)?.toFixed(
                    defaultBrokerageOrderOpposite
                      .reduce((sum, item) => sum + Number(item.sz || 0), 0)
                      ?.toString()
                      ?.split(".")[1]?.length,
                  )}{" "}
                  {columnSelected?.securitySymbol}
                </p>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Closed Size</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <p>
                  {defaultBrokerageOrderOpposite.reduce(
                    (sum, item) => sum + Number(item.sz || 0),
                    0,
                  )}{" "}
                  {columnSelected?.securitySymbol}
                </p>
              </Col>
            </Row>

            {!showReport && (
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col className="pl-0">
                  <UiButton
                    onClick={() => {
                      if (!isBrokerageFetchLoading) {
                        setShowReport(true);
                      }
                    }}
                    buttonVariant="primary"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText={
                      isBrokerageFetchLoading ? "Loading..." : "Continue"
                    }
                    type="submit"
                  />
                </Col>
              </Row>
            )}
            {showReport && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Settle Account Report:</b>
                  </Col>
                </Row>

                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Rate Tenure:</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    {columnSelected?.brokerage !== "HYPERLIQUID" && (
                      <p>
                        {rate} {rateTitle?.replace("s", "(s)")}
                      </p>
                    )}
                    {columnSelected?.brokerage === "HYPERLIQUID" && (
                      <p>1 hour</p>
                    )}
                  </Col>
                </Row>

                {isFinancing && (
                  <>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Bid %:</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        {columnSelected?.brokerage !== "HYPERLIQUID" && (
                          <p>
                            {(Number(financingAmounts?.bid) * 100)?.toFixed(6)}%
                          </p>
                        )}
                        {columnSelected?.brokerage === "HYPERLIQUID" && (
                          <p>{(Number(fundingRateHyper) * 100)?.toFixed(6)}%</p>
                        )}
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Offer %:</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        {columnSelected?.brokerage !== "HYPERLIQUID" && (
                          <p>
                            {(Number(financingAmounts?.offer) * 100)?.toFixed(
                              6,
                            )}
                            %
                          </p>
                        )}
                        {columnSelected?.brokerage === "HYPERLIQUID" && (
                          <p>{(Number(fundingRateHyper) * 100)?.toFixed(6)}%</p>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                {isDividends && (
                  <>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Dividend Bid %:</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <p>{Number(dividendsAmounts?.bid) * 100}%</p>
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Dividend Offer %:</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <p>{Number(dividendsAmounts?.offer) * 100}%</p>
                      </Col>
                    </Row>
                  </>
                )}

                {isSwaps && (
                  <>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Swaps Short %:</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <p>{Number(swapsAmounts?.short) * 100}%</p>
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Swaps Long %:</b>
                      </Col>
                      <Col className="pl-0" xs={3.5}>
                        <p>{Number(swapsAmounts?.long) * 100}%</p>
                      </Col>
                    </Row>
                  </>
                )}
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Trade PNL</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    {isBrokerageFetchLoading && <p>Calculating...</p>}
                    {!isBrokerageFetchLoading && (
                      <p>
                        {defaultBrokerageOrderOpposite.reduce(
                          (sum, item) => sum + Number(item.closedPnl || 0),
                          0,
                        )}{" "}
                        {columnSelected?.currencySymbol}
                      </p>
                    )}
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Deposited Collateral</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <p>
                      {columnSelected?.userDepositedCollateral?.toFixed(
                        Number(columnSelected?.currencyDecimals),
                      )}{" "}
                      {columnSelected?.currencySymbol}
                    </p>
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Total Fee</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <p>
                      {defaultBrokerageOrderOpposite.reduce(
                        (sum, item) => sum + Number(item.fee || 0),
                        0,
                      ) +
                        defaultBrokerageOrderDt.reduce(
                          (sum, item) => sum + Number(item.fee || 0),
                          0,
                        )}{" "}
                      {defaultBrokerageOrderDt[0]?.feeToken}
                    </p>
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Calculated PNL</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <p>
                      {(
                        Number(columnSelected?.userDepositedCollateral) +
                        Number(
                          defaultBrokerageOrderOpposite.reduce(
                            (sum, item) => sum + Number(item.closedPnl || 0),
                            0,
                          ),
                        ) -
                        Number(
                          defaultBrokerageOrderOpposite.reduce(
                            (sum, item) => sum + Number(item.fee || 0),
                            0,
                          ) +
                            defaultBrokerageOrderDt.reduce(
                              (sum, item) => sum + Number(item.fee || 0),
                              0,
                            ),
                        )
                      )?.toFixed(Number(columnSelected?.currencyDecimals))}{" "}
                      {columnSelected?.currencySymbol}
                    </p>
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col className="pl-0">
                    <UiButton
                      onClick={async () => {
                        if (!isBrokerageFetchLoading) {
                          await handleSettleAccount();
                        }
                      }}
                      buttonVariant="primary"
                      buttonClass="SignUpButton flex-1 ml-0"
                      buttonText="Settle Accounts"
                      type="submit"
                    />
                  </Col>
                </Row>
              </>
            )}
          </Row>
        </div>
      </>
    );
  }

  return (
    <>
      {_loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="">
            <h3 className="">{pageHeading}</h3>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={marginTrades || []}
            hover
            bordered={false}
            contract={marginManagerContractVer}
            chainId={chainId}
            signer={signer}
            web3={web3}
            verifiedWalletDetails={verifiedWalletDetails}
            account={account}
            commonProps={commonProps}
          />
        </div>
      </section>
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={handleModalHide}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>{heading}</b>
          </h2>
        }
        withFooter={false}
      >
        {message}
      </VerticallyModal>
    </>
  );
}

export default function MarginInvestorDetail(props) {
  return <InvestorInfo params={props?.match?.params} />;
}
